import { createContext, useContext } from 'react';
import { getOrCreateGlobalSingleton } from './globalObject.esm.js';
import { createVersionedValueMap } from './VersionedValue.esm.js';

function createVersionedContext(key) {
  return getOrCreateGlobalSingleton(
    key,
    () => createContext(void 0)
  );
}
function useVersionedContext(key) {
  return useContext(createVersionedContext(key));
}
function createVersionedContextForTesting(key) {
  return {
    set(versions) {
      globalThis[`__@backstage/${key}__`] = createContext(
        createVersionedValueMap(versions)
      );
    },
    reset() {
      delete globalThis[`__@backstage/${key}__`];
    }
  };
}

export { createVersionedContext, createVersionedContextForTesting, useVersionedContext };
//# sourceMappingURL=VersionedContext.esm.js.map
